import { ResponsiveLine } from "@nivo/line";
import { tokens } from "../theme";


const LineChart = ({data, isDashboard = false }) => {
  const colors = tokens();
  const formattedData = [
    {
      id: "Participantes por año", // nombre de la serie
      data: data.map((d) => ({
        x: d.label || d.id, // eje X
        y: d.value,         // eje Y
      })),
    },
  ];
  return (
    <ResponsiveLine
      data={formattedData}
      theme={{
        axis: {
          domain: {
            line: {
              stroke: colors.primary[100],
            },
          },
          legend: {
            text: {
              fill: colors.primary[100],
            },
          },
          ticks: {
            line: {
              stroke: colors.primary[100],
              strokeWidth: 1,
            },
            text: {
              fill: colors.primary[100],
            },
          },
        },
        legends: {
          text: {
            fill: colors.primary[100],
          },
        },
        tooltip: {
          container: {
            color: colors.primary[100],
          },
        },
      }}
      colors={colors.green[200]}
      margin={{ top: 25, right: 25, bottom: 25, left: 25 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      yFormat=" >-.2f"
      curve="catmullRom"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: "bottom",
        tickSize: 0,
        tickPadding: 5,
        tickRotation: 0,
        legend: isDashboard ? undefined : "Año", 
        legendOffset: 36,
        legendPosition: "middle",
      }}
      axisLeft={{
        orient: "left",
        tickValues: 5, 
        tickSize: 3,
        tickPadding: 5,
        tickRotation: 0,
        legend: isDashboard ? undefined : "cantidad", 
        legendOffset: -40,
        legendPosition: "middle",
      }}
      enableGridX={false}
      enableGridY={false}
      pointSize={8}
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={ colors.green[200] }
      pointLabelYOffset={-12}
      useMesh={true}
      legends={isDashboard ? [
        {anchor: "top-left", 
          translateX: 20,
          direction: "column",
          justify: false,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: "circle",
          symbolBorderColor: colors.grey[700],
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: colors.grey[700],
                itemOpacity: 1,
              },
            },
          ],}] 
        :[
        {
          anchor: "top-left",
          direction: "column",
          justify: false,
          translateX: 10,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: "circle",
          symbolBorderColor: colors.grey[700],
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: colors.grey[700],
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );
};

export default LineChart;